import { getThemeStrokeClass } from '@/lib/theme';
import { ITheme } from '@/types/theme';
import React from 'react';

interface WaveDividerProps {
  position: 'top' | 'bottom';
  backgroundColor: 'primary' | 'secondary';
  theme?: ITheme;
  emphasis?: boolean;
}

const WaveDivider: React.FC<WaveDividerProps> = ({
  position = 'top',
  backgroundColor,
  theme = null,
  emphasis = false,
}) => {
  // Don't render if backgroundColor is primary
  if (backgroundColor === 'primary') {
    return null;
  }

  // Full path for fill (closed shape)
  const fillPathData =
    position === 'top'
      ? 'M0,0 L0,50 Q300,100 600,80 T1200,50 L1200,0 Z'
      : 'M0,120 L0,70 Q300,20 600,40 T1200,70 L1200,120 Z';

  // Just the wave curve for stroke (no left/right edges)
  const strokePathData =
    position === 'top'
      ? 'M0,50 Q300,100 600,80 T1200,50'
      : 'M0,70 Q300,20 600,40 T1200,70';

  // For secondary background, use white/dark mode colors
  const fillColor = 'fill-white dark:fill-gray-900';
  const strokeColor = getThemeStrokeClass(theme);

  return (
    <div
      className={`${position === 'top' ? (emphasis ? 'mb-12' : 'mb-8') : emphasis ? 'mt-12' : 'mt-8'}`}
    >
      <div
        className={`absolute ${position === 'top' ? 'top-0 -translate-y-px' : 'bottom-0 translate-y-px'} left-0 w-full overflow-hidden leading-none`}
      >
        <svg
          className="relative block w-full h-20 md:h-24"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Fill layer */}
          <path d={fillPathData} className={fillColor} />
          {/* Stroke layer - only the wave curve */}
          <path
            d={strokePathData}
            fill="none"
            className={strokeColor}
            strokeWidth={emphasis ? 1.25 : 0.5}
          />
        </svg>
      </div>
    </div>
  );
};

export default WaveDivider;
